/*
 *
 * IBM Confidential
 *
 * OCO Source Materials
 *
 * (C) COPYRIGHT IBM CORP. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 *
 */
import { getTriAppConfig } from "@tririga/tririga-react-components";

const GET_PROFILE_URL = "/p/oauth/profile?forLogin=true";

export const OAuthProfileService = {
    getProfileList
};

async function getProfileList()
{
    let url = `${ getTriAppConfig().tririgaUrl }${ GET_PROFILE_URL }`;
    if (process.env.NODE_ENV==='development') {
        url = `${ "../../" }${ GET_PROFILE_URL }`;
    }

    const results = await fetch( url,
        {
            headers: {
                'Accept': 'application/json',
            },
            credentials: 'same-origin',
        }
    ).then(
        ( response ) =>
        {
            if( !response.ok )
            {
                throw response;
            }
            return response.text();
        }
    ).then(
        ( body ) =>
        {
            try
            {
                return JSON.parse( body );
            }
            catch( e )
            {
                const err = {
                    message: e.message,
                    body: body,
                };
                throw err;
            }
        }
    ).catch(
        err => { 
            if (err.status !== 404) {
                throw err; 
            }
        }
    );
    return results;
}